import React from 'react';
import { Link, useParams } from 'react-router-dom';
import PageHeader from '../Layout/PageHeader';
import '../../styles/projectDetails.css';
import { projectsData } from '../../data/projects';
import PS from '../../assets/images/playstore.png';

const ProjectDetails = () => {
  const { id } = useParams();
  const project = projectsData.find((item) => item.id === parseInt(id, 10));

  if (!project) {
    return (
      <main className="page">
        <div className="page__inner" style={{ textAlign: 'center' }}>
          <PageHeader title="Project not found" description="This project doesn't exist or was removed." />
          <Link to="/portfolio" className="button">Back to portfolio</Link>
        </div>
      </main>
    );
  }

  const ctaHref = project.websiteLink || project.playStoreLink;
  const ctaLabel = project.websiteLink ? 'Visit website' : 'Get it on Google Play';

  return (
    <main className="page">
      <div className="page__inner">
        <div className="surface-card project-details">
          <div className="project__image-wrap project-details__image-wrap">
            <img src={project.imageUrl} alt={project.title} className="project__image" />
          </div>
          <PageHeader label="Project" title={project.title} />
          <p className="project-details__meta"><strong>Role:</strong> {project.role}</p>
          <div className="project-details__stack">
            {project.stack.map((tech) => (
              <span key={tech} className="project-details__tag">{tech}</span>
            ))}
          </div>
          <p className="project-details__description">{project.description}</p>
          <p className="project-details__outcome"><strong>Outcome:</strong> {project.outcome}</p>
          {ctaHref && (
            <a
              href={ctaHref}
              className="project-details__button"
              target="_blank"
              rel="noopener noreferrer"
            >
              {ctaLabel}
              {!project.websiteLink && (
                <img src={PS} alt="" className="project-details__ps-icon" aria-hidden="true" />
              )}
            </a>
          )}
        </div>
      </div>
    </main>
  );
};

export default ProjectDetails;
